import AntecipacaoRecebiceisInterceptor from '@finx/web-repository/src/apis/AntecipacaoRecebiveis/AntecipacaoRecebiveisInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'

const factory = new FactoryResponse()
const api = new AntecipacaoRecebiceisInterceptor()

export default {
  async getAllAntecipacoes(params: any) {
    let query = '&paginar=true'

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    if (params.situacao || params.situacao === 0) query += `&situacao=${params.situacao}`
    if (params.empresaMedicaNome) query += `&empresaMedicaNome=${params.empresaMedicaNome}`
    if (params.documentoFontePagadora) query += `&documentoFontePagadora=${params.documentoFontePagadora}`
    if (params.hospital) query += `&hospital=${params.hospital}`
    if (params.solicitadoInicio) query += `&solicitadoInicio=${params.solicitadoInicio}`
    if (params.solicitadoFim) query += `&solicitadoFim=${params.solicitadoFim}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`antecipacoes/backoffice${query}`)
    return factory.build(request)
  },

  async getSituacoes() {
    const request = await api.get('antecipacoes/status')
    return factory.build(request)
  },

  async getAntecipacaoProfissional() {
    const request = await api.get('antecipacoes/creditos/disponiveis')
    return factory.build(request)
  },

  async getHistoricoAntecipacao(params: {
    dataInicio?: string | null
    dataFim?: string | null
    status?: number | string | null
    hospital?: string | null
    pagina?: number | null
    qtdPorPagina?: number | null
  } = {}) {
    let query = '&paginar=true'

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    if (params.dataInicio) query += `&dataSolicitacaoInicio=${params.dataInicio}`
    if (params.dataFim) query += `&dataSolicitacaoFim=${params.dataFim}`
    if (params.status !== null && params.status !== undefined && params.status !== '') {
      query += `&status=${encodeURIComponent(String(params.status))}`
    }
    if (params.hospital) query += `&hospital=${encodeURIComponent(params.hospital)}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`antecipacoes/obter-historico${query}`)
    return factory.build(request)
  },

  async getFontesPagadorasAntecipacao() {
    const request = await api.get('antecipacoes/fontes-pagadoras')
    return factory.build(request)
  },

  async submitAntecipacaoProfissional(payload: any) {
    const { creditoId, ...body } = payload
    const request = await api.post(`antecipacoes/creditos/${creditoId}/solicitacoes`, body)
    return factory.build(request)
  },

  async obterResumoAntecipacaoBackoffice() {
    const request = await api.get('antecipacoes/backoffice/obter-resumo')
    return factory.build(request)
  },

  async getTermoCessaoVigente() {
    const request = await api.get('termos-cessao/vigente')
    return factory.build(request)
  },

  async simularAntecipacao(params: { creditoId: string, valorSolicitado?: number | null }) {
    let url = `antecipacoes/creditos/${encodeURIComponent(params.creditoId)}/simulacao`
    if (params.valorSolicitado !== undefined && params.valorSolicitado !== null) {
      url += `?valorSolicitado=${params.valorSolicitado}`
    }

    const request = await api.get(url)
    return factory.build(request)
  },
}
